import { AxiosRequestConfig, Method } from 'axios';

import { axiosFetcher } from './axiosFetcher';
import { getCurrentUser } from './getCurrentUser';
import { getUserToken } from './getUserToken';

export type InvokeApiParams = {
  body?: AxiosRequestConfig['data'];
  method?: Method;
  params?: AxiosRequestConfig['params'];
  path: string;
};

export const invokeApi = async <T = any>({
  body,
  method = 'GET',
  params,
  path,
}: InvokeApiParams): Promise<T | undefined> => {
  const currentUser = getCurrentUser();

  if (!currentUser) return;

  let accessToken = '';

  try {
    accessToken = await getUserToken(currentUser);
  } catch (e) {
    console.error(e);
    return;
  }

  if (!accessToken) return;

  const headers: Record<string, string> = {
    Accept: 'application/json',
    Authorization: accessToken,
    'Content-Type': 'application/json',
  };

  return await axiosFetcher<T>(path, { body, headers, method, params });
};
